module.exports = __webpack_public_path__ + "static/media/icon_97.ce0fc475.svg";